<template>
  <div class="parent-invitation-section">
    <!-- AVATAR -->
    <div class="w-100 d-flex justify-content-center">
      <ParentIcon></ParentIcon>
    </div>
    <!-- AVATAR -->

    <!-- ONBOARDING TITLE -->
    <div class="onboarding-title font-weight-bold brand_navy text-center">
      Invite Parent
    </div>

    <!-- FORM AREA -->
    <form action @submit.prevent="sendInvitation">
      <!-- PARENT NAME -->
      <div class="form-group">
        <label for="parentName" class="control-label color_grey_dark"
          >Parent's Name</label
        >
        <input
          type="text"
          v-model="form.receiver_name"
          class="form-control"
          id="parentName"
          onKeyPress="if(this.value.length >= 50) return false;"
          placeholder="The name of your parent"
          required
          ref="nameInput"
          @input="checkInput"
        />
      </div>

      <!-- RELATIONSHIP -->
      <div class="form-group">
        <label for="relationship" class="control-label color_grey_dark"
          >Which of your parents is this?</label
        >
        <select
          class="form-control"
          id="relationship"
          v-model="form.role"
          required
          ref="roleInput"
          @change="checkInput"
        >
          <option value selected disabled>
            - Which of your parents is this? -
          </option>
          <option value="father">Father</option>
          <option value="mother">Mother</option>
          <option value="guardian">Guardian</option>
        </select>
      </div>

      <!-- PARENT EMAIL -->
      <div class="form-group">
        <label for="parentContact" class="control-label color_grey_dark"
          >Parent's Email / Phone</label
        >
        <input
          type="text"
          v-model="form.receiver_contact"
          class="form-control"
          id="parentContact"
          placeholder="Enter your parent’s contact"
          required
          ref="contactInput"
          @input="checkInput"
        />
      </div>

      <!-- PARENT NUMBER -->
      <div class="form-group" v-if="false">
        <label for="parentNumber" class="control-label color_grey_dark"
          >Parent’s phone number</label
        >
        <input
          type="number"
          v-model="form.receiver_phone"
          class="form-control"
          id="parentNumber"
          onKeyPress="if(this.value.length >= 11) return false;"
          placeholder="Enter phone"
          ref="phoneInput"
          @input="checkInput"
        />
      </div>

      <!-- SUBMIT BUTTON -->
      <div class="w-100 d-flex justify-content-center align-items-center my-5">
        <button
          type="submit"
          class="btn btn-accent font-weight-bold"
          ref="invitationBtn"
        >
          Send Invitation
        </button>
      </div>
    </form>

    <!-- MODALS -->
    <InvitationSuccessModal
      v-if="invitation_modal"
      :name="form.receiver_name"
      :role="role"
      @closeTriggered="toggleInvitationModal"
    ></InvitationSuccessModal>
    <!-- MODALS -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ParentIcon from "@/components/coloredIconPack/ParentIcon";
import { setTimeout } from "timers";

export default {
  name: "ParentInviteForm",

  components: {
    ParentIcon,
    InvitationSuccessModal: () =>
      import("@/components/modalComps/studentModals/InvitationSuccessModal"),
  },

  data() {
    return {
      invitation_modal: false,
      form: {
        receiver_name: "",
        role: "",
        receiver_contact: "",
        receiver_phone: "",
      },
      role: "",
    };
  },

  computed: {
    ...mapGetters(["getAuthUser"]),
  },

  mounted() {
    this.$refs.invitationBtn.disabled = true;
  },

  methods: {
    ...mapActions(["sendParentInvitation"]),

    toggleInvitationModal() {
      this.invitation_modal = !this.invitation_modal;
    },

    checkInput() {
      let name = this.$refs.nameInput.value;
      let role = this.$refs.roleInput.value;
      let contact = this.$refs.contactInput.value;

      name && role && contact
        ? (this.$refs.invitationBtn.disabled = false)
        : (this.$refs.invitationBtn.disabled = true);
    },

    sendInvitation() {
      this.$refs.invitationBtn.disabled = true;
      this.$refs.invitationBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      let modified_payload = {
        type: "parent",
        class_id: this.getAuthUser.class.id,
        school_id: this.getAuthUser.class.school_id,
        relationship: this.form.role,
        contacts: [{ email: this.form.receiver_contact }],
      };

      this.sendParentInvitation(modified_payload)
        .then((response) => {
          if (response.code === 200) {
            if (this.form.role === "father") this.role = "Dad";
            else if (this.form.role === "mother") this.role = "Mum";
            else this.role = "Guardian";

            setTimeout(() => {
              this.$refs.invitationBtn.disabled = false;
              this.$refs.invitationBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Successful';
            }, 1000);

            setTimeout(() => {
              this.$refs.invitationBtn.innerHTML = "Send Invitation";
              this.toggleInvitationModal();
            }, 2000);
          }
          // HANDLE NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.$refs.invitationBtn.disabled = false;
              this.$refs.invitationBtn.innerHTML =
                '<div class="icon-decline font-18 mr-2"></div>Failed';
            }, 1000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
</style>
